<template>
  <div class="zone-progress-bar">
    <div class="progressbar">
      <div
        class="element"
        v-for="(step, i) in steps"
        :key="step.number"
        :class="{
          'small': step.small,
          'filled': currentStep >= i + 1,
          'inactive': ((i + 1 === 3 || i + 1 === 4) && noSolidFuel) || (i + 1 === 6 && addressIsSame)
        }"
      >
        <div class="dot">
          {{ step.number }}
        </div>
        <label class="d-none d-md-flex">
          {{ step.title }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",

  data() {
    return {
      steps: [
        {
          title: "Metryka budynku",
          number: "1",
          small: false,
        },
        {
          title: "Źródła ciepła",
          number: "2",
          small: false,
        },
        {
          title: "Klasy kotłów",
          number: "2A",
          small: true,
        },
        {
          title: "Rodzaje paliw",
          number: "2B",
          small: true,
        },
        {
          title: "Dane kontaktowe",
          number: "3",
          small: false,
        },
        {
          title: "Dane adresowe",
          number: "3A",
          small: true
        },
      ]
    }
  },
  props: ['currentStep', 'noSolidFuel', 'addressIsSame']
}
</script>

<style scoped>
.zone-progress-bar {
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  font-weight: bold;
  color: #6f6f6f;
}

.progressbar {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  height: 100%;
}

.element {
  margin-top: .4rem;
  display: flex;
  align-items: baseline;
}

.dot {
  border-radius: 50%;
  border: 2px solid #6F6F6F;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  color: #6F6F6F;
  text-align: center;
}

.element.filled .dot {
  color: #FFFFFF;
  background-color: #6F6F6F;
}

.element label {
  vertical-align: middle;
  padding-left: 1rem;
  font-weight: bold;
}

.element.small .dot {
  font-weight: bold;
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.element.small label {
  padding-left: .5rem;
}

.progressbar li.active {
  color: #000000;
}

.progressbar li.active:before {
  background-color: #6F6F6F;
  border-color: #6F6F6F;
  color: #FFFFFF;
}

.inactive label {
  color: #d2d2d2 !important;
}

.inactive .dot {
  color: #d2d2d2 !important;
  border-color: #d2d2d2 !important;
  background-color: unset !important;
}

@media (max-height: 770px) {
  .progressbar {
    margin-top: .5rem;
  }
}
</style>
